import { CartDispensary } from "custom-types/CartDispensary";

const shouldUseJaneCheckout = (dispensary?: CartDispensary) =>
  dispensary?.isJaneRetailer &&
  dispensary?.janeStoreId &&
  (dispensary.hasDeliveryEnabled || dispensary.hasReservationsEnabled);

export default shouldUseJaneCheckout;
